import { format, parse } from "date-fns"
import PropTypes from "prop-types"
import React from "react"

const FuelDockAvailability = ({ fuelDockAvailability }) => {
  const formatTime = (timeString) => {
    if (!timeString) return ""
    try {
      return format(
        parse(timeString, "HH:mm", new Date()),
        "h:mm a"
      ).toLowerCase()
    } catch (error) {
      return ""
    }
  }

  const formatSeasonDate = (month, day) => {
    if (!month || !day) return ""
    try {
      // Use a fixed year to avoid issues with leap years
      const date = parse(`${month}/${day}/2024`, "M/d/yyyy", new Date())

      return format(date, "MMMM, do")
    } catch (error) {
      console.warn("Error formatting season date:", error)
      return `${month}/${day}`
    }
  }

  // Get the days of week in order
  const daysOfWeek = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ]

  // Formatted names for display
  const dayNames = {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  }

  // Get array of all days with their formatted time ranges or "Closed"
  const formattedDays = daysOfWeek.map((day) => {
    const dayData = fuelDockAvailability.days[day]

    if (!dayData?.enabled) {
      return {
        name: dayNames[day],
        timeRange: "Closed",
      }
    }

    const startTime = formatTime(dayData.timeRange.start)
    const endTime = formatTime(dayData.timeRange.end)
    return {
      name: dayNames[day],
      timeRange: `${startTime} to ${endTime}`,
    }
  })

  const season = fuelDockAvailability.season
  const seasonText = () => {
    if (season.yearRound) {
      return "Open Year Round"
    } else {
      return `Open from ${formatSeasonDate(
        season.startMonth,
        season.startDay
      )} - ${formatSeasonDate(season.endMonth, season.endDay)}`
    }
  }

  return (
    <div className="h-min w-full rounded border p-4">
      <h2 className="mb-2 text-lg font-bold">Fuel Dock Hours</h2>
      <div className="mb-2 font-bold">{seasonText()}</div>
      <div className="space-y-2">
        {formattedDays.map((day) => (
          <div key={day.name} className="grid grid-cols-12 gap-2">
            <div className="col-span-5">
              <span className="font-semibold">{day.name}</span>
            </div>
            <div className="col-span-7">
              <span>{day.timeRange}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

FuelDockAvailability.propTypes = {
  fuelDockAvailability: PropTypes.shape({
    season: PropTypes.shape({
      yearRound: PropTypes.bool,
      startMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      startDay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      endMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      endDay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    enabled: PropTypes.bool,
    days: PropTypes.object,
  }),
}

export default FuelDockAvailability
